/**
 * Whether a finished turn is worth opening a panel for, unasked.
 *
 * Opening a panel takes the screen away from the conversation, so the bar is
 * a turn that produced something the user will want to look at rather than
 * read about. A linked pull request wins outright — it is the turn's outcome.
 * Otherwise the working tree has to have changed enough to be worth a look;
 * a one-line edit is faster to read in the transcript than in a diff.
 */

export const PROACTIVE_DIFF_FILE_THRESHOLD = 3;
export const PROACTIVE_DIFF_LINE_THRESHOLD = 50;

export type ProactivePanelTarget = "pull-requests" | "diff";

export function planProactivePanel(input: {
  readonly enabled: boolean;
  /** True once this thread has a pull request the user could open. */
  readonly hasLinkedPullRequest: boolean;
  readonly changedFileCount: number;
  readonly changedLineCount: number;
  /** A panel already on screen is the user's choice; nothing overrides it. */
  readonly panelAlreadyOpen: boolean;
}): ProactivePanelTarget | null {
  if (!input.enabled || input.panelAlreadyOpen) return null;
  if (input.hasLinkedPullRequest) return "pull-requests";
  if (
    input.changedFileCount >= PROACTIVE_DIFF_FILE_THRESHOLD ||
    input.changedLineCount >= PROACTIVE_DIFF_LINE_THRESHOLD
  ) {
    return "diff";
  }
  return null;
}
